<span *ngIf="!showSpinner && projectId">
  <button type="button" [ngClass]="getClass()" class="project-icon-menu"
          placement="bottom-right"
          [ngbTooltip]="'MENU_PROJECT' | translate"
          [matMenuTriggerFor]="menu">
        <fa-icon [icon]="iconService.faBars"></fa-icon>
    <span *ngIf="!forGraphicComponent">&nbsp;&nbsp;{{'PROJECTS_MENU' | translate}}</span>
</button>


<mat-menu #menu="matMenu" class="{{ forGraphicComponent ? 'icon-menu-graphic-component' : 'icon-menu' }}">

<button type="button" [ngClass]="getClass()" class="document"
        (click)="openLink(project?.document_url)" placement="bottom"
        [ngbTooltip]="'DOCUMENT_URL' | translate"
        [disabled]="!propertyExists(project?.document_url)">
<fa-icon [icon]="iconService.faFolderOpen"></fa-icon>
</button>


<button type="button" [ngClass]="getClass()" style="background: crimson " placement="bottom"
        [ngbTooltip]="'TOOL_MENU_NOTES' | translate"
        [routerLink]="'/project-notations/'+  projectId" routerLinkActive="btn-active"
        *ngIf="authenticationService.userHasRoleOsmos()">
  <fa-icon [icon]="iconService.faGraduationCap"></fa-icon>
</button>

<button type="button" [ngClass]="getClass()" style="background: cornflowerblue " placement="bottom"
        [ngbTooltip]="'TOOL_MENU_MAPS' | translate"
        [routerLink]="'/project-locations-map/'+  projectId" routerLinkActive="btn-active"
        *ngIf="authenticationService.userHasRoleOsmos()">
  <fa-icon [icon]="iconService.faGlobe"></fa-icon>
</button>

<button type="button" [ngClass]="getClass()" style="background: #e91e63 " placement="bottom"
        [ngbTooltip]="'TOOL_MENU_PLANS' | translate"
        [routerLink]="'/project-locations-plan/'+  projectId " routerLinkActive="btn-active"
        *ngIf="authenticationService.userHasRoleOsmos()">
  <fa-icon [icon]="iconService.faMap"></fa-icon>
</button>

  <!--<button type="button" [ngClass]="getClass()" style="background: #1C4670 " placement="bottom"-->
  <!--        [ngbTooltip]="('PROJECTS_MENU_MAP_LOCATIONS' | translate) + ' & ' + ('PROJECTS_MENU_PLANS' | translate)"-->
  <!--        [routerLink]="'/project-locations-map-plan/'+  projectId " routerLinkActive="btn-active">-->
  <!--  <fa-icon [icon]="iconService.faMapMarkedAlt"></fa-icon>-->
  <!--</button>-->

<button type="button" [ngClass]="getClass()" style="background: hotpink"
        (click)="openLastMeasureModal(projectId)" placement="bottom"
        [ngbTooltip]="'LAST_MEASURE_TOOLTIP' | translate">
  <fa-icon [icon]="iconService.faClock"></fa-icon>
</button>

  <button type="button" [ngClass]="getClass()" class="wimd"
          [routerLink]="'/project-wimd/'+projectId" placement="bottom"
          [ngbTooltip]="'WIM+D'" routerLinkActive="btn-active"
          [disabled]="!wimdSub">
  <fa-icon [icon]="iconService.faTruck"></fa-icon>
</button>

<button type="button" [ngClass]="getClass()" class="eventdyn"
        [routerLink]="'/event-dyn/'+projectId" placement="bottom"
        [ngbTooltip]="'EVENTDYN_TOOLTIP' | translate" routerLinkActive="btn-active"
        [disabled]="!project.project_status_third_party_data?.eventdyn_subscription_id">
  <fa-icon [icon]="iconService.faBolt"></fa-icon>
</button>


<button *ngIf="!forGraphicComponent" type="button" [ngClass]="getClass()" style="background: #f44336"
        (click)="openGraphicalViewListModal()" placement="bottom"
        [ngbTooltip]="'TOOL_MENU_VIEWS' | translate">
  <fa-icon [icon]="iconService.faList"></fa-icon>
</button>

<button type="button" [ngClass]="getClass()" style="background: orangered"
        [routerLink]="'/project-last-alarms/'+projectId" placement="bottom"
        [ngbTooltip]="'LAST_ALARM_TOOLTIP' | translate" routerLinkActive="btn-active">
  <fa-icon [icon]="iconService.faExclamationTriangle"></fa-icon>
</button>


 <button *ngIf="!forGraphicComponent" type="button" [ngClass]="getClass()" style="background: darkgreen"
         (click)="openExportCsvModal(project.id, project.start_date, project.end_date)" placement="bottom"
         [ngbTooltip]="'CSV_EXPORT_TOOLTIP' | translate">
<fa-icon [icon]="iconService.faFileExcel"></fa-icon>
</button>


<button *ngIf="!forGraphicComponent" type="button" [ngClass]="getClass()" style="background: cornflowerblue"
        [routerLink]="'/chart/'+projectId" placement="bottom"
        [ngbTooltip]="'CHART_TOOLTIP' | translate" routerLinkActive="btn-active">
  <fa-icon [icon]="iconService.faChartLine"></fa-icon>
</button>
  </mat-menu>

    <button type="button" [ngClass]="getClass()" style="background: cornflowerblue  " placement="bottom-right"
            [ngbTooltip]="('HOME_PAGE' | translate)"
            [routerLink]="'/project-locations-map-plan/'+project.id">
          <fa-icon [icon]="iconService.faHome"></fa-icon>
        </button>
   <div *ngIf="!forGraphicComponent" class="sub-menu-project-name">{{project.name}}</div>
</span>
